import { devLog } from "@/lib/devLog";
/**
 * Safe wrappers around localStorage so that disabled / quota-exceeded /
 * sandboxed (private-mode) browsers don't take the whole app down at
 * provider mount. All errors are swallowed and logged once at debug
 * level — every consumer must be tolerant of a `null` read or a no-op
 * write because those are also the legitimate "key doesn't exist" /
 * "writes disabled" outcomes.
 */

const log = (msg, err) => {
  // Use debug so noisy iframes don't spam the console.
  devLog(`[safeStorage] ${msg}`, err);
};

export function safeGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (err) {
    log(`getItem("${key}") blocked`, err);
    return null;
  }
}

export function safeSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (err) {
    log(`setItem("${key}") blocked`, err);
  }
}

export function safeRemove(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (err) {
    log(`removeItem("${key}") blocked`, err);
  }
}
